import { render } from "./EarnPage.vue?vue&type=template&id=4d22cf6e&scoped=true"
import script from "./EarnPage.vue?vue&type=script&lang=js"
export * from "./EarnPage.vue?vue&type=script&lang=js"

import "./EarnPage.vue?vue&type=style&index=0&id=4d22cf6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d22cf6e"]])

export default __exports__